import React from 'react'
import { IconType } from 'react-icons'

interface IconProps {
  icon: IconType
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number
  color?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'accent'
    | 'cyan'
    | 'purple'
    | 'pink'
    | string
  className?: string
  'aria-label'?: string
}

const sizeMap = {
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
}

const colorMap = {
  primary: 'var(--color-text-primary)',
  secondary: 'var(--color-text-secondary)',
  tertiary: 'var(--color-text-tertiary)',
  accent: 'var(--color-accent)',
  cyan: 'var(--color-cyan)',
  purple: 'var(--color-purple)',
  pink: 'var(--color-pink)',
}

export const Icon: React.FC<IconProps> = ({
  icon: IconComponent,
  size = 'md',
  color = 'primary',
  className = '',
  'aria-label': ariaLabel,
  ...props
}) => {
  const iconSize = typeof size === 'number' ? size : sizeMap[size]
  const iconColor =
    color in colorMap ? colorMap[color as keyof typeof colorMap] : color

  return (
    <IconComponent
      size={iconSize}
      color={iconColor}
      className={`icon ${className}`}
      aria-label={ariaLabel}
      {...props}
    />
  )
}

export default Icon
